<template>
  <div
    :style="{ width: width && `${width}px`, height: height && `${height}px` }"
    :class="['svg-icon', `ui-icon__display-${display}`]"
    v-html="icon"
  ></div>
</template>

<script lang="ts" setup>
import { PropType, ref } from 'vue';

import { DisplayType, IconType } from './types';

const props = defineProps({
  name: {
    type: String as PropType<IconType>,
    required: true,
  },
  width: {
    type: [String, Number],
    required: false,
    default: '',
  },
  height: {
    type: [String, Number],
    required: false,
    default: '',
  },
  display: {
    type: String as PropType<DisplayType>,
    required: false,
    default: 'inline',
  },
});

const icon = ref('');

async function init() {
  try {
    icon.value = (await import(`./icons/${props.name}.svg?raw`)).default;
  } catch (e) {
    console.log(`No icon with such name '${props.name}'`, e);
  }
}

init();
</script>
